var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1221_477)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.0424,
    cy: 31.0424,
    r: 25.0424,
    fill: "#2879F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3917 36.5146H36.8032V31.6916H41.6262V29.2802H36.8032V24.4572H34.3917V29.2802H29.5688V31.6916H34.3917V36.5146ZM35.5975 42.5433C33.9295 42.5433 32.3621 42.2266 30.8951 41.5932C29.4281 40.9598 28.152 40.1009 27.0668 39.0165C25.9817 37.9314 25.1228 36.6553 24.4902 35.1883C23.8576 33.7213 23.5408 32.1539 23.54 30.4859C23.54 28.818 23.8567 27.2505 24.4902 25.7835C25.1236 24.3165 25.9825 23.0404 27.0668 21.9553C28.152 20.8701 29.4281 20.0112 30.8951 19.3786C32.3621 18.746 33.9295 18.4293 35.5975 18.4285C37.2654 18.4285 38.8329 18.7452 40.2999 19.3786C41.7669 20.012 43.0429 20.8709 44.1281 21.9553C45.2133 23.0404 46.0726 24.3165 46.706 25.7835C47.3394 27.2505 47.6557 28.818 47.6549 30.4859C47.6549 32.1539 47.3382 33.7213 46.7048 35.1883C46.0714 36.6553 45.2125 37.9314 44.1281 39.0165C43.0429 40.1017 41.7669 40.961 40.2999 41.5944C38.8329 42.2278 37.2654 42.5441 35.5975 42.5433ZM35.5975 40.1319C38.2903 40.1319 40.5712 39.1974 42.4401 37.3285C44.309 35.4596 45.2434 33.1787 45.2434 30.4859C45.2434 27.7931 44.309 25.5122 42.4401 23.6433C40.5712 21.7744 38.2903 20.84 35.5975 20.84C32.9046 20.84 30.6238 21.7744 28.7549 23.6433C26.886 25.5122 25.9515 27.7931 25.9515 30.4859C25.9515 33.1787 26.886 35.4596 28.7549 37.3285C30.6238 39.1974 32.9046 40.1319 35.5975 40.1319Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1221_477",
    x: 0,
    y: 0,
    width: 70.085,
    height: 70.0847,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1221_477"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1221_477",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddbtn);
export default __webpack_public_path__ + "static/media/addbtn.d1079ad492abf96056e8cdf950c73bbd.svg";
export { ForwardRef as ReactComponent };